import React from 'react';
import ReactDOM from 'react-dom';
import { isFragment } from 'react-is';
export function addEventListenerWrap(target, eventType, cb, option) {
    var callback = ReactDOM.unstable_batchedUpdates
        ? function run(e) {
            ReactDOM.unstable_batchedUpdates(cb, e);
        }
        : cb;
    if (target && target.addEventListener) {
        target.addEventListener(eventType, callback, option);
    }
    return {
        remove: function () {
            if (target && target.removeEventListener) {
                target.removeEventListener(eventType, callback);
            }
        },
    };
}
export function toArray(children, option) {
    if (option === void 0) { option = {}; }
    var ret = [];
    React.Children.forEach(children, function (child) {
        if ((child === undefined || child === null) && !option.keepEmpty) {
            return;
        }
        if (Array.isArray(child)) {
            ret = ret.concat(toArray(child));
        }
        else if (isFragment(child) && child.props) {
            ret = ret.concat(toArray(child.props.children, option));
        }
        else {
            ret.push(child);
        }
    });
    return ret;
}
